<div class="col-md-12">
  <div class="row" style="padding-top: 15px">
    <div class="col-md-12 mt-2 mb-3">
      <h4 class="flex-align-items space-between mb-0">
        <span>{{ 'ErrorHandler.title' | translate }} </span>
        <button (click)="addCustomPagesProfile()" class="btn btn-sm btn-primary btn-sm" type="button">
          <i class="icofont icofont-ui-add"></i>
          <span>{{ 'ErrorHandler.add' | translate }}</span>
        </button>
      </h4>
    </div>
  </div>
  <!--
    <div class="row mb-1">
      <div class="col-md-3">
        <div class="form-group">
          <input
            (ngModelChange)="onSearch($event)"
            [(ngModel)]="search"
            class="form-control form-control-sm"
            id="search"
            placeholder="{{ 'ErrorHandler.search.placeHolder' | translate }}"
            type="text"
          />
        </div>
      </div>
    </div>
  -->
  <div class="table-responsive">
    <table class="table table-striped table-condensed" style="border: 1px solid #ccc">
      <thead>
        <tr>
          <th class="name">{{ 'ErrorHandler.name' | translate }}</th>
          <th>{{ 'ErrorHandler.profiledConfigured' | translate }}</th>
          <th>{{ 'ErrorHandler.comment' | translate }}</th>
          <th>{{ 'ErrorHandler.lastModified' | translate }}</th>
          <th class="actions">{{ 'Actions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!customPagesProfileModels.length">
          <td colspan="5" style="text-align: center">{{ 'NoData' | translate }}</td>
        </tr>
        <tr
          *ngFor="
            let row of customPagesProfileModels
              | paginate
                : {
                    itemsPerPage: size,
                    currentPage: page + 1,
                    totalItems: nbCustomPagesProfileModels,
                  }
          "
        >
          <td>
            <div class="td-name">
              <a [routerLink]="['custom-pages-profiles', row.uid]">{{ row.name }}</a>
              <app-badge-organization [code]="row.uid" [type]="'uid'"></app-badge-organization>
            </div>
          </td>
          <td>{{ getErrors(row) }}</td>
          <td [title]="row.comment" class="text-ellipsis" style="max-width: 50vh">
            {{ row.comment }}
          </td>
          <td [title]="row.updatedAt | dateFormat: 'long'">
            {{ row.updatedAt | dateFormat: 'date' }}
          </td>
          <td class="actions">
            <a [routerLink]="['custom-pages-profiles', row.uid]">
              <i class="icon icon-settings" title="{{ 'Configuration' | translate }}"></i>
            </a>
            <i
              (click)="deleteCustomPagesProfile(row)"
              class="icofont icofont-ui-delete"
              title="{{ 'supprimer' | translate }}"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="flex-align-items pull-right">
      <div class="sites-total mr-3">Total : {{ nbCustomPagesProfileModels }}</div>
      <pagination-controls
        (pageChange)="changePage($event)"
        *ngIf="customPagesProfileModels.length"
        nextLabel="{{ 'Next' | translate }}"
        previousLabel="{{ 'Previous' | translate }}"
        style="margin-top: 10px"
      ></pagination-controls>
    </div>
  </div>
</div>
